import { Box, Flex, Grid, Skeleton } from '@chakra-ui/react';
import { browseColors } from './browse-tokens';

/** Loading placeholder mirroring the program card layout. Borders only, no shadow. */
const ProgramCardSkeleton = () => (
  <Box
    bg={browseColors.cardBg}
    border="1px solid"
    borderColor={browseColors.cardBorder}
    borderRadius="18px"
    p="20px 20px 14px"
  >
    <Skeleton h="20px" w="72px" borderRadius="6px" />
    <Skeleton mt="12px" h="18px" w="60%" borderRadius="6px" />
    <Skeleton mt="10px" h="12px" w="100%" borderRadius="4px" />
    <Skeleton mt="6px" h="12px" w="80%" borderRadius="4px" />
    <Skeleton mt="14px" h="26px" w="128px" borderRadius="full" />

    <Grid mt="14px" templateColumns="repeat(4, 1fr)" gap="8px">
      {Array.from({ length: 4 }).map((_, index) => (
        <Box key={index}>
          <Skeleton h="10px" w="80%" borderRadius="4px" />
          <Skeleton mt="6px" h="14px" w="60%" borderRadius="4px" />
        </Box>
      ))}
    </Grid>

    <Flex
      mt="14px"
      pt="10px"
      gap="6px"
      borderTop="1px solid"
      borderColor={browseColors.footerBorder}
    >
      <Skeleton h="30px" w="128px" borderRadius="full" />
      <Skeleton h="30px" w="88px" borderRadius="full" />
      <Skeleton h="30px" w="30px" borderRadius="full" ml="auto" />
    </Flex>
  </Box>
);

export default ProgramCardSkeleton;
